//import "./.css";
import Loading from "../../public/others/LoadingFull";
import { Button } from "react-bootstrap";
import "../../../styles/admin/news.css";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";

export default function NewBanner() {
  const navigate = useNavigate();
  const [img, setImg] = useState("");
  const [link, setLink] = useState("");
  const [visible, setVisible] = useState(true);
  const [removeLoading, setRemoveLoading] = useState(true); //loading

  useEffect(() => {
    // console.log(img);

    const img2 = img || " "; // se imag for undefined, a img2 será uma string vazia

    if (img2 !== " ") {
      const resultType = img2.type.split("/");
      if (resultType[0] === "image") {
        //aceita apenas no formato de imagem
        //se for imagem tá tudo ok

        // How to use in an async function

        let imgRender = new Image();

        imgRender.src = window.URL.createObjectURL(img);
        imgRender.onload = () => {
          const width = imgRender.width;
          const height = imgRender.height;
          if (width < 1400 && height < 400) {
            alert("A imagem selecionada não é tem o tamanho ideal");
            setImg("");
          }
        };
      } else {
        alert("Selecione uma imagem");
        setImg("");
      }
    } else if (img2 !== undefined) {
      //setImg({'name': 'LOGO.png', 'lastModified': 1652564602649, 'lastModifiedDate': 'Sat May 14 2022 18:43:22 GMT-0300 (Horário Padrão de Brasília)','webkitRelativePath': '', 'size': 47355,})
    }
  }, [img]);

  const handleOnChange = () => {
    setVisible(!visible);
  };
  //submit formulário
  const handleSubmit = async (e) => {
    e.preventDefault();

    setRemoveLoading(false);

    const dataJson = new FormData();

    if (visible === true) {
      dataJson.append("available", 1);
    } else {
      dataJson.append("available", 0);
    }
    dataJson.append("type", 1); //Banner especifico de um portal
    dataJson.append("imgBanner", img);
    dataJson.append("link", link);
    console.log(link, img);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    await api
      .post(`/banner/new`, dataJson, headers)
      .then((res) => {
        if (res.data.err) {
          alert("Ocorreu um erro, tente novamente!!!");
          setRemoveLoading(true);
        } else {
          alert("O Banner foi criado com Sucesso");
          setRemoveLoading(true);
          navigate("/admin/banner/painel");
        }
      })
      .catch((err) => {
        setRemoveLoading(true);
        setRemoveLoading(true);
        alert("Ocorreu um erro, tente novamente!!!");
      });
  };

  return (
    <div className="container-noticia">
      {!removeLoading && <Loading />}
      <div className="sub-header-news">
        <h2>Criar Notícia</h2>
        <Button
          className="btn-success"
          variant="primary"
          href="/admin/banner/painel"
        >
          Voltar para lista
        </Button>
      </div>
      <main>
        <form onSubmit={handleSubmit} className="form-admin-news">
          <span>
            O Banner deve possuir os tamanhos: 1400px de altura e 400px de
            largura
          </span>

          <label className="input-file-container">
            <input
              type="file"
              name="imgTop"
              accept="image/*"
              className="custom-input-file"
              onChange={(e) => setImg(e.target.files[0])}
            />

            {img !== "" && img !== undefined ? (
              <a
                href={URL.createObjectURL(img)}
                target="_blank"
                rel="noopener noreferrer"
                title="Visualizar imagem"
              >
                <img
                  src={URL.createObjectURL(img)}
                  alt="imagem selecionada"
                  className="img-show-select select-top"
                />
              </a>
            ) : (
              <Button className="button-selecionar">Selecionar Banner</Button>
            )}
            {img !== "" && img !== undefined && (
              <Button className="button-selecionar">
                Selecionar Outra Imagem
              </Button>
            )}
          </label>

          <label className="form-input">
            Link do banner:
            <input
              type="text"
              name="link-botão"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </label>

          <label className="form-input checkbox">
            <input
              type="checkbox"
              name="select-visible"
              id="checkbox-visible"
              checked={visible}
              onChange={() => setVisible(!visible)}
            />
            <span className="checkmark"></span>
            <p>Status: {visible ? "Visível ao público" : "Não Visível"}</p>
          </label>

          <br />
          <Button type="submit" className="btn-success" variant="primary">
            Enviar banner
          </Button>
        </form>
      </main>
    </div>
  );
}
